<template>
  <div>
    <Breadcrumb :dataSource="breadcrumbList" />
    <div class="page-container" style="padding-top: 0">
      <a-tabs :default-active-key="tabKey" @change="handleTabChange">
        <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
          <div class="query-area">
            <j-dict-select-tag
              style="width: 150px; margin-right: 15px"
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :isShowEmpty="false"
              @select="$set(queryParam, 'classId', undefined)"
            />
            <j-dict-select-tag
              style="width: 150px; margin-right: 15px"
              placeholder="请选择班级"
              v-model="queryParam.classId"
              :dictCode="
                'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
              "
              :async="true"
              :disabled="!queryParam.gradeId"
              :isShowEmpty="false"
            />
            <j-dict-select-tag
              v-model="queryParam.care"
              placeholder="请选择关爱等级"
              dictCode="care_list"
              class="search-space"
              style="width: 150px"
              :isShowEmpty="false"
            />
            <a-select
              v-model="queryParam.warnStatus"
              placeholder="请选择处理状态"
              style="width: 150px; margin-right: 15px"
              :options="handleOpts"
              allowClear
            />
            <a-select
              v-model="queryParam.continuousFlag"
              placeholder="是否连续提醒"
              style="width: 150px; margin-right: 15px"
              :options="reminderOpts"
              allowClear
            />
            <j-dict-select-tag
              v-model="reasonKey"
              placeholder="请选择提醒原因"
              dictCode="reminder_reason"
              class="search-space"
              style="width: 150px"
              :isShowEmpty="false"
            />
            <a-range-picker
              v-model="dateRange"
              class="search-space"
              style="width: 220px"
              @change="changeDateRange"
            />
            <a-input-search
              v-model="queryParam.studentName"
              placeholder="请输入学生名字"
              class="search-space"
              style="width: 150px"
              @change="searchName"
            />
            <a-button type="primary" @click="queryTable">查询</a-button>
            <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 15px">
              重置
            </a-button>
          </div>
          <div class="flex-align-end">
            <a-popconfirm
              v-if="identityId == 1"
              title="确定要一键提醒班主任吗？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="oneKeyUrgeDo"
            >
              <a-button type="primary" :loading="btnLoading" style="margin-right: 15px">
                一键提醒班主任
              </a-button>
            </a-popconfirm>
            <a-button
              icon="download"
              :loading="exportXlsLoading"
              @click="handleExportXls(item.tab)"
            >
              导出
            </a-button>
          </div>

          <TableList
            :columns="columns"
            :tableData="dataSource"
            bordered
            :loading="loading"
            :scroll="{}"
            :pagination="ipagination"
            @change="handleTableChange"
            style="min-height: 350px"
          >
            <div class="flex-align-center" slot="labelsList" slot-scope="{ record }">
              <span
                v-for="(item, index) in record.labelsList"
                :key="index"
                :style="{
                  color: getStuTagColorConfig(item.key).color,
                  background: getStuTagColorConfig(item.key).bgColor,
                }"
                class="label-item"
              >
                {{ item.text }}
              </span>
            </div>
            <span slot="weekRemind" slot-scope="{ record }">
              <img
                v-if="record.weekRemind == '1'"
                src="@/assets/imgs/commonPage/remind.png"
                alt=""
                style="width: 20px; height: 20px"
              />
              <span v-else>未提醒</span>
            </span>
            <template slot="action" slot-scope="{ record }">
              <div class="action-detail">
                <span @click="viewArchives(record)" class="action-span">查看档案</span>
                <span @click="addLedger(record)" class="action-span">添加台账</span>
                <span @click="addVisitRecord(record)" class="action-span">添加家访记录</span>
              </div>
            </template>
          </TableList>
        </a-tab-pane>
      </a-tabs>
    </div>
    <AddLedgerModal ref="addLedgerModalRef" @refreshData="loadData" />
    <!-- 添加家访记录 -->
    <AddVisitRecordModal ref="visitRecordModalRef" @refreshData="loadData" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction, postAction } from '@api/manage'
import { getDictCodeData, simpleDebounce, getStuTagColorConfig } from '@/utils/util'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Breadcrumb from '@/components/Breadcrumb/index'
import { mapGetters } from 'vuex'
import { getSchoolTerm } from '@/utils/termDate'
import AddLedgerModal from '@/views/school/mentalHealth/TutorStandBook/components/StudentTutor/components/AddLedgerModal'
import AddVisitRecordModal from '@/views/school/mentalHealth/CrisisIntervent/components/AddVisitRecordModal'
import { formatYearMonthDate, getMonthDateRange, getWeekDateRange } from '@/utils/date'

const { startDate, endDate } = getSchoolTerm()
const dateRangMapObj = {
  week: getWeekDateRange(), // 本周日期范围
  month: getMonthDateRange(), // 本月日期范围
  term: [startDate, endDate], // 本学期日期范围
}

export default {
  name: 'XddRemindStudent',
  components: {
    Breadcrumb,
    TableList,
    AddLedgerModal,
    AddVisitRecordModal
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      breadcrumbList: [
        {
          label: '心理工作概览 ',
          isBack: true,
        },
        {
          label: '提醒学生',
        },
      ],
      tabKey: 1,
      reasonKey: undefined,
      dateRange: [],
      handleOpts: [
        {
          label: '已处理',
          value: 1,
        },
        {
          label: '未处理',
          value: 2,
        },
      ],
      reminderOpts: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      // tab列表配置
      tabPaneConfig: [
        // {
        //   tab: '总提醒人数',
        //   key: 1,
        // },
        // {
        //   tab: '一、二、三级提醒',
        //   key: 2,
        // },
        // {
        //   tab: '连续提醒(>2次)',
        //   key: 3,
        // },
        // {
        //   tab: '四特学生提醒',
        //   key: 4,
        // },
      ],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '班主任',
          dataIndex: 'teacherName',
          align: 'center',
        },
        {
          title: '学生标签',
          dataIndex: 'labelsList',
          align: 'center',
          scopedSlots: { customRender: 'labelsList' },
        },
        {
          title: '关爱等级',
          dataIndex: 'care_dictText',
          align: 'center',
        },
        {
          title: '提醒原因',
          dataIndex: 'reason',
          align: 'center',
        },
        {
          title: '提醒时间',
          dataIndex: 'warnTime',
          align: 'center',
        },
        {
          title: '家长电话',
          dataIndex: 'phone',
          align: 'center',
        },
        {
          title: '处理状态',
          dataIndex: 'warnStatus',
          align: 'center',
          customRender: (_, record) => (
            <div style={{ color: record.warnStatus == 1 ? '#F87654' : '' }}>
              {getDictCodeData('student_warn_status', record.warnStatus, true)}
            </div>
          ),
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/statisticV2/getMoodReminderCategoriesV2',
        exportXlsUrl: '/statisticV2/exportMoodReminderXls',
      },
      disableMixinCreated: true,
      btnLoading: false,
      timeType: 'week',
    }
  },
  created() {
    const query = this.$route.query
    const currIndex = query.index
    if (currIndex) {
      this.tabKey = Number(currIndex)
      this.queryParam.type = this.tabKey
    }
    this.timeType = query?.timeType
    if (dateRangMapObj?.[query.timeType]) {
      this.dateRange = dateRangMapObj[query.timeType]
    }
    if (query?.beginDate && query?.endDate) {
      this.dateRange = [query.beginDate, query.endDate]
    }
    this.queryParam.beginDate = this.dateRange?.[0]
    this.queryParam.endDate = this.dateRange?.[1]
    // pendingCount大于0，默认勾选未处理
    if (query.pendingCount > 0) {
      this.$set(this.queryParam, 'warnStatus', 2)
    }
    // 是否勾选连续提醒
    if (query.continuousFlag == 1) {
      this.$set(this.queryParam, 'continuousFlag', 1)
    }
    this.getReminderTab().then(() => {
      this.loadData(1)
    })
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    ...mapGetters(['identityId']),
  },
  methods: {
    getStuTagColorConfig,
    addLedger(row){
      this.$refs.addLedgerModalRef.showModal({
        gradeId:row.gradeId,
        classId:row.classId,
        studentId:row.studentId
      },"append")
    },
    // 添加家访记录
    addVisitRecord(row) {
      this.$refs.visitRecordModalRef.showModal(
        {
          gradeId: row.gradeId,
          classId: row.classId,
          studentId: row.studentId,
        },
        'append'
      )
    },
    queryTable() {
      if (this.reasonKey) {
        this.queryParam.reason = getDictCodeData('reminder_reason', this.reasonKey, true)
      } else {
        this.queryParam.reason = undefined
      }
      this.searchQuery()
    },
    // 提醒学生概况
    async getReminderTab() {
      const res = await getAction('/statisticV2/getReminderDataList', {
        timeType: this.timeType,
      })
      const { success, result } = res
      if (success) {
        this.tabPaneConfig = result.map((item, index) => ({
          tab: item.typeName,
          key: item.type,
        }))
      }
    },
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam.type = key
      this.loadData(1)
    },
    changeDateRange(dateArr) {
      if (dateArr.length) {
        this.dateRange = [formatYearMonthDate(dateArr[0]), formatYearMonthDate(dateArr[1])]
      } else {
        this.dateRange = []
      }
      this.queryParam.beginDate = this.dateRange?.[0]
      this.queryParam.endDate = this.dateRange?.[1]
    },
    searchName: simpleDebounce(function (event) {
      this.queryParam.studentName = event.target?.value
      this.loadData(1)
    }, 800),
    // 重置
    searchReset() {
      this.queryParam = {}
      this.dateRange = []
      this.queryParam.type = this.tabKey
      this.loadData(1)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    async oneKeyUrgeDo() {
      this.btnLoading = true
      const res = await postAction('/statisticV2/getMoodReminderCategoriesV2Push', {
        type: this.tabKey,
        continuousFlag: this.queryParam.continuousFlag,
      })
      this.btnLoading = false
      const { success } = res
      if (success) {
        this.$message.success('一键提醒班主任成功')
        return
      }
      this.$message.error('一键提醒班主任失败')
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}

.search-space {
  width: 140px;
  margin-right: 15px;
}

.label-item {
  margin: 0 4px;
  padding: 2px 8px;
  color: #575757;
  background-color: #fafafa;
  border-radius: 12px;
}
.action-span{
  display: inline-block;
  margin-right: 10px;
}
</style>
